import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { ProductContext } from '../../App';

function AddSoldOutOrder({ addSoldOutOrder, setAddSoldOutOrder }) {
    const { setIsLoading, alert, setAlert } = useContext(ProductContext);
    const { isOpen, order, reload } = addSoldOutOrder;
    const [inputs, setInputs] = useState({
        customerName: '',
        instaId: '',
        contact: '',
        address: '',
        itemName: '',
    })

    useEffect(() => {
        if (order) {
            setInputs({
                customerName: order?.customerName || '',
                instaId: order?.instaId || '',
                contact: order?.contact || '',
                address: order?.address || '',
                itemName: order?.itemName || '',
            })
        }
    }, [order])

    const handleInputsChange = (e) => {
        setInputs({ ...inputs, [e.target.name]: e.target.value });
    }

    const handleOrderSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (order.contact) {
            axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/extra-order/${order._id}`, inputs)
                .then(res => {
                    setAlert({
                        isOpen: true,
                        message: "New Order Added",
                        type: "success",
                    });
                    reload();
                    setIsLoading(false);
                    setAddSoldOutOrder({ ...addSoldOutOrder, isOpen: false });
                })
                .catch(err => {
                    setIsLoading(false);
                    setAlert({
                        isOpen: true,
                        message: "Something Went Wrong",
                        type: "danger",
                    });
                });
        }
        else {
            axios.post(`${process.env.REACT_APP_SERVER_DOMAIN}/extra-order`, inputs)
                .then(res => {
                    setAlert({
                        isOpen: true,
                        message: "New Order Added",
                        type: "success",
                    });
                    reload();
                    setIsLoading(false);
                    setAddSoldOutOrder({ ...addSoldOutOrder, isOpen: false });
                })
                .catch(err => {
                    setIsLoading(false);
                    setAlert({
                        isOpen: true,
                        message: "Something Went Wrong",
                        type: "danger",
                    });
                });
        }
        setTimeout(() => {
            setAlert({ ...alert, isOpen: false });
        }, 5000);
    }
    return (
        <>
            {isOpen ? <div className='back'>
                <div className="edit-container flex-column">
                    <h2 className='text-white'>Add Order</h2>
                    <div className="edit-form">
                        <form onSubmit={handleOrderSubmit}>
                            <div className="inputs">
                                <label htmlFor="customerName">Customer Name</label>
                                <input type="text" required
                                    placeholder='Enter Name' name='customerName'
                                    value={inputs.customerName}
                                    onChange={(e) => { handleInputsChange(e) }}
                                />
                            </div>
                            <div className="inputs">
                                <label htmlFor="instaId">Instagram Id</label>
                                <input type="text"
                                    placeholder='Enter Insta Id' name='instaId'
                                    value={inputs.instaId}
                                    onChange={(e) => { handleInputsChange(e) }}
                                />
                            </div>
                            <div className="inputs">
                                <label htmlFor="contact">Contact</label>
                                <input type="text" required
                                    placeholder='Enter Contact' name='contact'
                                    value={inputs.contact}
                                    onChange={(e) => { handleInputsChange(e) }}
                                />
                            </div>
                            <div className="inputs">
                                <label htmlFor="address">Address</label>
                                <input type="text"
                                    placeholder='Enter Address' name='address'
                                    value={inputs.address}
                                    onChange={(e) => { handleInputsChange(e) }}
                                />
                            </div>
                            <div className="inputs">
                                <label htmlFor="itemName">Item Name</label>
                                <input type="text" required
                                    placeholder='Enter Item Name' name='itemName'
                                    value={inputs.itemName}
                                    onChange={(e) => { handleInputsChange(e) }}
                                />
                            </div>
                            <div>
                                <button type='submit' className='btn btn-success mx-2'>Submit</button>
                                <button onClick={() => {
                                    setAddSoldOutOrder({ ...addSoldOutOrder, isOpen: false });
                                }} className='btn btn-danger'>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> : null}

        </>
    )
}

export default AddSoldOutOrder
